export default {
  arrives: 'Arrives',
  journeyDuration: 'Journey duration',
}
